<template>
  <div class="baseContainter">
<BaseFrame
  logText="操作日志"
  :infosArr='titleInfo'
  :idText='"商品ID"'
  :id='id'
  :logData='records'

  @hanldeLog='hanldeLog'>
  <!-- <lk-affix>
        <div class="subHeader">
          <div class="breadcrumb">
            <lk-breadcrumb>
              <lk-breadcrumb-item to="goodsBaseList">基本商品列表</lk-breadcrumb-item>
              <lk-breadcrumb-item to="storeFirst">门店首营</lk-breadcrumb-item>
              <lk-breadcrumb-item to="storeFirstInfo">门店首营信息</lk-breadcrumb-item>
            </lk-breadcrumb>
          </div>
        </div>
        <div class="info">
          <lk-row>
            <lk-col span='4'>
              <div>商品ID:001</div>
            </lk-col>
          </lk-row>
          <lk-row>
            <lk-col span='4'>
              <div>商品名称:吉非替尼</div>
            </lk-col>
            <lk-col span='4'>
              <div>批准文号:吉非替尼</div>
            </lk-col>
            <lk-col span='4'>
              <div>规格:吉非替尼</div>
            </lk-col>
            <lk-col span='4'>
              <div>门店名称:吉非替尼</div>
            </lk-col>
            <lk-col span='4'>
              <div>首营审批状态:</div>
            </lk-col>
          </lk-row>
        </div>
      </lk-affix> -->
  <div slot="content">
    <lk-card title='供应商及价格信息'>
      <lk-form :model='goodsForm' :label-width='140' label-position="right" ref="goodsForm">
        <lk-row :gutter='16'>
          <lk-col span=11>
            <lk-form-item label='供应商:' prop='supplierStoreId'>
              <span>{{goodsForm.goodsStore.supplierStoreName}}</span>
            </lk-form-item>
          </lk-col>
          <lk-col span=11>
            <lk-form-item label='进项税率:' prop='inputTaxRate'>
              <span>{{goodsForm.goodsStore.inputTaxRate}}%</span>
            </lk-form-item>
          </lk-col>

          <lk-col span=11>
            <lk-form-item label='销项税率:' prop='outputTaxRate'>
              <span>{{goodsForm.goodsStore.outputTaxRate}}%</span>
            </lk-form-item>
          </lk-col>
          <lk-col span=11>
            <lk-form-item label='默认进货价（元）:' prop='defPurchasePrice'>
              <span>{{goodsForm.goodsStore.defPurchasePrice}}</span>
            </lk-form-item>
          </lk-col>

          <lk-col span=11>
            <lk-form-item label='默认零售价（元）:' prop='defRetailPrice'>
              <span>{{goodsForm.goodsStore.defRetailPrice}}</span>
            </lk-form-item>
          </lk-col>
          <lk-col span=11>
            <lk-form-item label='助记码:' prop='mnemonicCode'>
              <span>{{goodsForm.goodsStore.mnemonicCode}}</span>
            </lk-form-item>
          </lk-col>

          <lk-col span=11>
            <lk-form-item label='成本类型:' prop='paymentType'>
              <span>{{goodsForm.paymentTypeString}}</span>
            </lk-form-item>
          </lk-col>
          <lk-col span=11>
            <lk-form-item label='是否DTP:' prop='paymentType'>
              <span>{{judgeArr[goodsForm.goodsStore.isDtp]}}</span>
            </lk-form-item>
          </lk-col>
          <lk-col span=11>
            <lk-form-item label='养护类型:' prop='paymentType'>
              <span>{{curingStandardArr[goodsForm.goodsStore.curingStandard]}}</span>
            </lk-form-item>
          </lk-col>


          <lk-col span=11>
            <lk-form-item label='是否医保:' prop='isMedicare'>
              <span>{{isMedicalArr[goodsForm.goodsStore.isMedicare]}}</span>
            </lk-form-item>
          </lk-col>
          <lk-col span=11>
            <lk-form-item label='医保名称:' prop='medicareName'>
              <span>{{goodsForm.goodsStore.medicareName}}</span>
            </lk-form-item>
          </lk-col>

          <!-- <lk-col span=11>
            <lk-form-item label='养护类型:' prop='curingStandard'>
              <span>{{curingStandardArr[goodsForm.goodsStore.curingStandard]}}</span>
            </lk-form-item>
          </lk-col> -->
          <lk-col span=11>
            <lk-form-item label='有效期禁止销售天数:' prop='periodForbidSaleDays'>
              <span>{{goodsForm.goodsStore.periodForbidSaleDays}}</span>
            </lk-form-item>
          </lk-col>

          <lk-col span=11>
            <lk-form-item label='有效期预警天数:' prop='periodAlertDays'>
              <span>{{periodAlertDays}}</span>
            </lk-form-item>
          </lk-col>
          <lk-col span=11>
            <lk-form-item label='库存预警上限:' prop='inventoryWarningMax'>
              <span>{{goodsForm.goodsStore.inventoryWarningMax}}</span>
            </lk-form-item>
          </lk-col>
          <lk-col span=11>
            <lk-form-item label='库存预警下限:' prop='inventoryWarning'>
              <span>{{goodsForm.goodsStore.inventoryWarning}}</span>
            </lk-form-item>
          </lk-col>
           <lk-col span='11' >
                <lk-form-item label='用药周期:' prop='initUsageCycle'>
                  <span >{{goodsForm.goodsStore.initUsageCycle}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span=11 >
                <lk-form-item label='回访提醒天数:' prop='initRemindDays'>
                 <span >{{goodsForm.goodsStore.initRemindDays}}</span>
                </lk-form-item>
              </lk-col>
        </lk-row>
      </lk-form>

    </lk-card>
    <div class="cardContainer">
    </div>
    <lk-card title='证件信息'>
      <lk-form :label-width='130' label-position="right" :model='goodsForm.goodsBase'>
        <lk-row :gutter='16'>
          <lk-col span='10' v-if="goodsForm.isHaveBusinessLicence">
            <lk-row>
              <lk-col span='24'>
                <lk-form-item>
                  <div class="label withPic">
                    <label>营业执照:</label>
                  </div>
                  <Uploader :able='false' v-model="goodsForm.businessLicenseUrl"></Uploader>

                </lk-form-item>
              </lk-col>
              <lk-col span='24'>
                <lk-form-item label='证件号:'>
                  <span>{{goodsForm.businessLicenceCode}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span='24'>
                <lk-form-item label='有效期:'>
                  <span>{{goodsForm.businessLicenceEffectivePeriod|formatDate}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
          </lk-col>
          <lk-col span='10' v-if="goodsForm.isHaveGsp">
            <lk-row>
              <lk-col span='24'>
                <lk-form-item>
                  <div class="label withPic">
                    <label>GSP证书:</label>
                  </div>
                  <Uploader :able='false' v-model="goodsForm.gspUrl"></Uploader>

                </lk-form-item>
              </lk-col>
              <lk-col span='24'>
                <lk-form-item label='证件号:'>
                  <span>{{goodsForm.gspCode}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span='24'>
                <lk-form-item label='有效期:'>
                  <span>{{goodsForm.gspEffectivePeriod|formatDate}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
          </lk-col>
          <lk-col span='10' v-if="goodsForm.isHaveDrugBusinessCredential">
            <lk-row>
              <lk-col span='24'>
                <lk-form-item>
                  <div class="label withPic">
                    <label>药品经营许可证:</label>
                  </div>
                  <Uploader :able='false' v-model="goodsForm.drugBusinessCredentialUrl"></Uploader>

                </lk-form-item>
              </lk-col>
              <lk-col span='24'>
                <lk-form-item label='证件号:'>
                  <span>{{goodsForm.drugBusinessCredentialCode}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span='24'>
                <lk-form-item label='有效期:'>
                  <span>{{goodsForm.drugBusinessCredentialEffectivePeriod|formatDate}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
          </lk-col>
          <lk-col span='10' v-if="goodsForm.isHaveGmp">
            <lk-row>
              <lk-col span='24'>
                <lk-form-item>
                  <div class="label withPic">
                    <label>GMP证书:</label>
                  </div>
                  <Uploader :able='false' v-model="goodsForm.gmpUrl"></Uploader>

                </lk-form-item>
              </lk-col>
              <lk-col span='24'>
                <lk-form-item label='证件号:'>
                  <span>{{goodsForm.gmpCode}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span='24'>
                <lk-form-item label='有效期:'>
                  <span>{{goodsForm.gmpEffectivePeriod|formatDate}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
          </lk-col>
          <lk-col span='10' v-if="goodsForm.isHaveDrugProductCredential">
            <lk-row>
              <lk-col span='24'>
                <lk-form-item>
                  <div class="label withPic">
                    <label>药品生产许可证:</label>
                  </div>
                  <Uploader :able='false' v-model="goodsForm.drugProductCredentialUrl"></Uploader>

                </lk-form-item>
              </lk-col>
              <lk-col span='24'>
                <lk-form-item label='证件号:'>
                  <span>{{goodsForm.drugProductCredentialCode}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span='24'>
                <lk-form-item label='有效期:'>
                  <span>{{goodsForm.drugProductCredentialEffectivePeriod|formatDate}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
          </lk-col>
          <lk-col span='10' v-if="goodsForm.isHaveFoodCredential">
            <lk-row>
              <lk-col span='24'>
                <lk-form-item>
                  <div class="label withPic">
                    <label>食品许可证:</label>
                  </div>
                  <Uploader :able='false' v-model="goodsForm.foodCredentialUrl"></Uploader>

                </lk-form-item>
              </lk-col>
              <lk-col span='24'>
                <lk-form-item label='证件号:'>
                  <span>{{goodsForm.foodCredentialCode}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span='24'>
                <lk-form-item label='有效期:'>
                  <span>{{goodsForm.foodCredentialEffectivePeriod|formatDate}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
          </lk-col>
          <lk-col span='10' v-if="goodsForm.isHaveFirstMedicalEquipment">
            <lk-row>
              <lk-col span='24'>
                <lk-form-item>
                  <div class="label withPic">
                    <label>第一类医疗器械证书:</label>
                  </div>
                  <Uploader :able='false' v-model="goodsForm.firstMedicalEquipmentUrl"></Uploader>

                </lk-form-item>
              </lk-col>
              <lk-col span='24'>
                <lk-form-item label='证件号:'>
                  <span>{{goodsForm.firstMedicalEquipmentCode}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span='24'>
                <lk-form-item label='有效期:'>
                  <span>{{goodsForm.firstMedicalEquipmentEffectivePeriod|formatDate}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
          </lk-col>
          <lk-col span='10' v-if="goodsForm.isHaveSecondMedicalEquipment">
            <lk-row>
              <lk-col span='24'>
                <lk-form-item>
                  <div class="label withPic">
                    <label>第二类医疗器械证书:</label>
                  </div>
                  <Uploader :able='false' v-model="goodsForm.secondMedicalEquipmentUrl"></Uploader>

                </lk-form-item>
              </lk-col>
              <lk-col span='24'>
                <lk-form-item label='证件号:'>
                  <span>{{goodsForm.secondMedicalEquipmentCode}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span='24'>
                <lk-form-item label='有效期:'>
                  <span>{{goodsForm.secondMedicalEquipmentEffectivePeriod|formatDate}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
          </lk-col>
          <lk-col span='10' v-if="goodsForm.isHaveThirdMedicalEquipment">
            <lk-row>
              <lk-col span='24'>
                <lk-form-item>
                  <div class="label withPic">
                    <label>第三类医疗器械证书:</label>
                  </div>
                  <Uploader :able='false' v-model="goodsForm.thirdMedicalEquipmentUrl"></Uploader>

                </lk-form-item>
              </lk-col>
              <lk-col span='24'>
                <lk-form-item label='证件号:'>
                  <span>{{goodsForm.thirdMedicalEquipmentCode}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span='24'>
                <lk-form-item label='有效期:'>
                  <span>{{goodsForm.thirdMedicalEquipmentEffectivePeriod|formatDate}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
          </lk-col>

          <!-- 新增 -->
          <lk-col span='10' v-if="goodsForm.goodsBase.prodLicenseUrl">
            <lk-col span='24'>
              <lk-form-item>
                <div class="label withPic">
                  <label>生产许可证:</label>
                </div>
                <Uploader :able='false' v-model.trim="goodsForm.goodsBase.prodLicenseUrl"></Uploader>
              </lk-form-item>
            </lk-col>
            <lk-col span='24'>
              <lk-form-item label='证件号:'>
                <span>{{goodsForm.goodsBase.prodLicenseCode}}</span>
              </lk-form-item>
            </lk-col>
            <lk-col span='24'>
              <lk-form-item label='有效期:'>
                <span>{{goodsForm.goodsBase.periodProdLicense|formatDate}}</span>
              </lk-form-item>
            </lk-col>
          </lk-col>
          <lk-col span='10' v-if="goodsForm.goodsBase.gmpCertUrl">
            <lk-col span='24'>
              <lk-form-item>
                <div class="label withPic">
                  <label>GMP证书:</label>
                </div>
                <Uploader :able='false' v-model.trim="goodsForm.goodsBase.gmpCertUrl"></Uploader>
              </lk-form-item>
            </lk-col>
            <lk-col span='24'>
              <lk-form-item label='证件号:'>
                <span>{{goodsForm.goodsBase.gmpCertCode}}</span>
              </lk-form-item>
            </lk-col>
            <lk-col span='24'>
              <lk-form-item label='有效期:'>
                <span>{{goodsForm.goodsBase.periodGmpCert|formatDate}}</span>
              </lk-form-item>
            </lk-col>
          </lk-col>


          <lk-col span='10' v-if="goodsForm.goodsBase.drugRegApprovalUrl">
            <lk-col span='24'>
              <lk-form-item>
                <div class="label withPic">
                  <label>药品注册批件:</label>
                </div>
                <Uploader :able='false' v-model.trim="goodsForm.goodsBase.drugRegApprovalUrl"></Uploader>
              </lk-form-item>
            </lk-col>
            <lk-col span='24'>
              <lk-form-item label='证件号:'>
                <span>{{goodsForm.goodsBase.drugRegApprovalCode}}</span>
              </lk-form-item>
            </lk-col>
            <lk-col span='24'>
              <lk-form-item label='有效期:'>
                <span>{{goodsForm.goodsBase.periodDrugRegApproval|formatDate}}</span>
              </lk-form-item>
            </lk-col>
          </lk-col>
          <lk-col span='10' v-if="goodsForm.goodsBase.inspectionReportUrl">
            <lk-col span='24'>
              <lk-form-item>
                <div class="label withPic">
                  <label>检验报告书:</label>
                </div>
                <Uploader :able='false' v-model.trim="goodsForm.goodsBase.inspectionReportUrl"></Uploader>
              </lk-form-item>
            </lk-col>
            <lk-col span='24'>
              <lk-form-item label='证件号:'>
                <span>{{goodsForm.goodsBase.inspectionReportCode}}</span>
              </lk-form-item>
            </lk-col>
            <lk-col span='24'>
              <lk-form-item label='有效期:'>
                <span>{{goodsForm.goodsBase.periodInspectionReport|formatDate}}</span>
              </lk-form-item>
            </lk-col>
          </lk-col>
          <lk-col span='10' v-if="goodsForm.goodsBase.importRegCertUrl">
            <lk-col span='24'>
              <lk-form-item>
                <div class="label withPic">
                  <label>进口注册证:</label>
                </div>
                <Uploader :able='false' v-model.trim="goodsForm.goodsBase.importRegCertUrl"></Uploader>
              </lk-form-item>
            </lk-col>
            <lk-col span='24'>
              <lk-form-item label='证件号:'>
                <span>{{goodsForm.goodsBase.importRegCertCode}}</span>
              </lk-form-item>
            </lk-col>
            <lk-col span='24'>
              <lk-form-item label='有效期:'>
                <span>{{goodsForm.goodsBase.periodImportRegCert|formatDate}}</span>
              </lk-form-item>
            </lk-col>
          </lk-col>
          <lk-col span='10' v-if="goodsForm.goodsBase.drugImageUrl">
            <lk-col span='24'>
              <lk-form-item>
                <div class="label withPic">
                  <label>药品图片:</label>
                </div>
                <Uploader :able='false' v-model.trim="goodsForm.goodsBase.drugImageUrl"></Uploader>
              </lk-form-item>
            </lk-col>

            </lk-col>


        </lk-row>
      </lk-form>
    </lk-card>
  </div>
</BaseFrame>

  </div>
</template>
<script>
import goodsStore from '../../../services/goods';
import BaseFrame from '../../../components/frame/BaseFrame.vue';
import Uploader from '../../../components/Uploader.vue';
import utils from '../../../libs/utils';

export default {
  name: 'StoreFirstInfo',
  components: { BaseFrame, Uploader },
  data() {
    return {
      records: [],
      id: '',
      titleInfo: [],
      // paymentTypeArr: ['', '支付宝', '现金', '信用卡', '微信'],
      curingStandardArr: ['', '一般养护', '重点养护'],
      isMedicalArr: ['', '是', '否'],
      judgeArr: ['', '是', '否'],
      periodAlertDaysArr: [],
      goodsForm: {
        goodsBase: {},
        goodsStore: {
          id: '', // 首营商品ID
          inputTaxRate: '', // 进项税率
          outputTaxRate: '', // 销项税率
          defPurchasePrice: '', // 默认进货价（元）
          defRetailPrice: '', // 默认零售价（元）
          mnemonicCode: '', // 助记码
          paymentType: '', // 成本类型
          inventoryWarning: '', // 库存预警
          supplierStoreId: '', // 门店首营供应商ID
          supplierStoreName: '',
          isMedicare: '', // 是否医保
          medicareName: '', // 医保名称
          curingStandard: '', // 养护类型
          periodForbidSaleDays: '', // 有效期禁止销售天数
          periodAlertDays: '', // 有效期预警天数
        },
        goodsBaseVO: {
          goodsBase: {
            id: '',
            approvedDrugNames: '', // 商品通用名
            approvalNumber: '', // 批准文号
            specifications: '', // 规格
            goodsName: '', // 商品名称
            chemicalComposition: '', // 化学成分
            dosageForm: '', // 剂型
            drugMiniPackageUnit: '', // 包装单位
            storageConditions: '', // 储存条件
            ndcNumber: '', // 本位码
            countryOfOrigin: '', // 产地
            qualityOfDrugsType: '', // 质检分类
            drugAcceptanceStandard: '', // 质检标准
            isImport: '', // 是否进口
            manufacturer: '', //	生产企业
            barCode: '', // 条形码
            decoctionBucket: '', // 门店装斗
            apparRegNumber: '', // 器械注册证号
            apparRecordCertCode: '', // 器械备案凭证编码
            indicationDicId: '', // 商品分类
            prodLicenseUrl: '', // 生产许可证
            prodLicenseCode: '', // 证件号,
            periodProdLicense: '', // 有效期
            gmpCertUrl: '', // GMP证书
            gmpCertCode: '', // 证件号
            periodGmpCert: '', // 有效期
            drugRegApprovalUrl: '', // 药品注册批件
            drugRegApprovalCode: '', // 药品注册批件号
            periodDrugRegApproval: '', // 药品注册批件有效期
            inspectionReportUrl: '', // 检验报告书
            inspectionReportCode: '', // 检验报告号
            periodInspectionReport: '', // 检验报告书有效期
            importRegCertUrl: '', // 进口注册证
            importRegCertCode: '', // 进口注册证号
            periodImportRegCert: '', // 进口注册证有效期
          },
          goodsLabelIds: [],
        },
        isHaveBusinessLicence: false,
        businessLicenseUrl: '',
        businessLicenceEffectivePeriod: '',
        businessLicenceCode: '',

        isHaveGsp: false,
        gspUrl: '',
        gspEffectivePeriod: '',
        gspCode: '',

        isHaveDrugBusinessCredential: false,
        drugBusinessCredentialUrl: '',
        drugBusinessCredentialEffectivePeriod: '',
        drugBusinessCredentialCode: '',

        isHaveGmp: false,
        gmpUrl: '',
        gmpEffectivePeriod: '',
        gmpCode: '',

        isHaveDrugProductCredential: false,
        drugProductCredentialUrl: '',
        drugProductCredentialEffectivePeriod: '',
        drugProductCredentialCode: '',

        isHaveFoodCredential: false,
        foodCredentialUrl: '',
        foodCredentialEffectivePeriod: '',
        foodCredentialCode: '',

        isHaveFirstMedicalEquipment: false,
        firstMedicalEquipmentUrl: '',
        firstMedicalEquipmentEffectivePeriod: '',
        firstMedicalEquipmentCode: '',

        isHaveSecondMedicalEquipment: false,
        secondMedicalEquipmentUrl: '',
        secondMedicalEquipmentEffectivePeriod: '',
        secondMedicalEquipmentCode: '',

        isHaveThirdMedicalEquipment: false,
        thirdMedicalEquipmentUrl: '',
        thirdMedicalEquipmentEffectivePeriod: '',
        thirdMedicalEquipmentCode: '',
      },
    };
  },
  computed: {
    breadcrumb() {
      const breadcrumb = [{
        name: this.$route.meta.menuNav,
        title: this.$route.meta.parentTitle,
      },
        // this.$route.meta.parentTitle,
      ];
      if (this.$route.meta.subTitle) {
        breadcrumb.push({
        // name: this.$route.meta.menuNav,
          title: this.$route.meta.subTitle,
        });
      }
      return breadcrumb;
    },
    periodAlertDays() {
      let result = '';
      this.periodAlertDaysArr.forEach((item) => {
        if (item.dictionaryIndex === this.goodsForm.goodsStore.periodAlertDays) {
          result = item.dictionaryName;
        }
      });
      return result;
    },
  },
  methods: {
    hanldeLog() { // 操作日志预留
      this.getRecord();
    },
    getDetail() {
      goodsStore.getGoodsStoreById({ id: this.$route.params.id }).then((res) => {
        if (res.data.status === 200) {
          // console.log(res.data);
          const data = res.data.data.goodsBaseVO;
          this.id = data.goodsBase.drugSerialCode;
          this.titleInfo = [
            { name: '商品通用名：', value: data.goodsBase.approvedDrugNames },
            { name: '创建人：', value: data.goodsBase.createUserName },
            { name: '创建时间：', value: data.goodsBase.createTime ? utils.exchangeTimeToSecond(data.goodsBase.createTime) : '' },
            { name: '最后修改人：', value: data.goodsBase.modifiedUserName },
            { name: '最后修改时间：', value: data.goodsBase.modifiedTime ? utils.exchangeTimeToSecond(data.goodsBase.modifiedTime) : '' },
          ];
          this.goodsForm = res.data.data;
          this.goodsForm.goodsBase = data.goodsBase;
          // this.goodsForm.goodsStore.defPurchasePrice = utils.exchangePercent(this.goodsForm.goodsStore.defPurchasePrice);
          // this.goodsForm.goodsStore.defRetailPrice = utils.exchangePercent(this.goodsForm.goodsStore.defRetailPrice);
        }
      });
    },
    getRecord() {
      goodsStore.getStoreRecord({ id: this.$route.params.id }).then((res) => {
        if (res.data.status === 200) {
          this.records = res.data.data;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getSelectArrs() {
      return new Promise((resolve) => {
        this.periodAlertDaysArr = [];

        goodsStore.GoodsDictionary({ dictionaryTypeEnum: 10 }).then((res) => {
          if (res.data.status === 200) {
            this.periodAlertDaysArr[0] = '';
            res.data.data.forEach((item) => {
              this.periodAlertDaysArr.push(item);
            });
            resolve();
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },
  },
  mounted() {
    this.getSelectArrs().then(() => {
      this.getDetail();
    });
  },
};
</script>
<style lang="less" scoped>
.baseContainter{
  .subHeader{
    height: 64px;
    padding:0 32px;
    line-height: 64px;
    background: #fff;
    display: flex;
    justify-content: space-between;
    .ctrls>*{
      margin-left: 16px
    }
  }
  .content{
    padding: 16px;
  }
  .info{
    background: #fff;
    padding:0  32px;
    padding-bottom: 20px;
    font-size: 14px;
    color: rgba(0,0,0,0.65);
  }
	.info div:first-child{
		color: rgba(0,0,0,0.75);
	}
}
.padding-span{
  padding-left:15px;
}
.cardContainer{
  margin-bottom: 16px
}
</style>
